<div class="container">
    <div class="side-nav">
        <div class="neo-tabs vertical">
            <div class="neo-tab" [class.active]="currentTab() === 'personal-settings'"
                (click)="switchCurrentTab('personal-settings')">
                Personal Settings
            </div>
            <div class="neo-tab" [class.active]="currentTab() === 'roles-permission-settings'"
                (click)="switchCurrentTab('roles-permission-settings')">
                Roles & Permissions Settings
            </div>
        </div>
    </div>
    @if (currentTab() === "personal-settings") {
    <div class="content-wrapper">
        <div class="content neo-scrollbar" [class.no-bg]="currentTab() === 'roles-permission-settings'" [class.no-footer]="!userPrivileges.has('user.update')">
            <div class="section" [formGroup]="personalDetails">
                <div class="section-heading">
                    Personal Settings
                </div>
                <div class="section-content">
                    <!-- Profile -->
                    <div class="section-item">
                        <div class="section-item-heading">
                            Profile
                        </div>
                        <div class="section-item-content">
                            <div class="">
                                <div class="neo-avatar" size="lg">
                                    {{userName | initials}}
                                </div>
                            </div>
                            <div class="username">
                                <div class="neo-input-wrapper">
                                    <label for="first_name">First Name</label>
                                    <input pInputText type="text" name="first_name" id="first_name" [readonly]="!userPrivileges.has('user.update')"
                                        formControlName="first_name">
                                </div>
                                <div class="neo-input-wrapper">
                                    <label for="last_name">Last Name</label>
                                    <input pInputText type="text" name="last_name" id="last_name" [readonly]="!userPrivileges.has('user.update')"
                                        formControlName="last_name">
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- Email -->
                    <div class="section-item">
                        <div class="section-item-heading">
                            Email Address
                        </div>
                        <div class="section-item-content">
                            <div class="email-wrapper">
                                <span class="your-email">Your email address is <span
                                        class="email">{{userName.email}}</span></span>
                                <p-button *ngIf="userPrivileges.has('user.update')" link label="Change" (click)="openAddTemplate('Change Email', 'pi-at')"></p-button>
                            </div>
                        </div>
                    </div>
    
                    <!-- Password -->
                    <div class="section-item">
                        <div class="section-item-heading">
                            Password
                        </div>
                        <div class="section-item-content">
                            <div class="username">
                                <div class="neo-input-wrapper">
                                    <label for="current_password">
                                        Current Password
                                    </label>
                                    <div>
                                        <input pInputText type="text" name="current_password" id="current_password" readonly
                                            value="********">
                                        <p-button link label="Reset Password"
                                            (click)="openAddTemplate('Change Password', 'pi-key')"></p-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- Contact -->
                    <div class="section-item no-border">
                        <div class="section-item-heading">
                            Contact
                        </div>
                        <div class="section-item-content">
                            <div class="username">
                                <div class="neo-input-wrapper">
                                    <label for="mobile_number">Mobile</label>
                                    <p-inputMask inputId="mobile_number" id="mobile_number" mask="9999999999" formControlName="mobile_number"
                                        [readonly]="!userPrivileges.has('user.update')"></p-inputMask>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper-footer" *ngIf="userPrivileges.has('user.update')">
            <button pButton class="create-btn" (click)="saveTemplateNew()" [disabled]="saveBtnLoading" [loading]="saveBtnLoading">
                Save Changes
            </button>
        </div>
    </div>
    }

    @if (currentTab() === "roles-permission-settings") {
    <div class="content-wrapper-roles">
        <div class="section with-bg">
            <div class="individual-section">
                <div class="section-heading">
                    Role Details
                </div>
                <div class="section-content">
                    <div class="section-item">
                        <div class="section-item-content">
                            <div class="username">
                                <div class="neo-input-wrapper">
                                    <label for="current_password">
                                        Role Name
                                    </label>
                                    <div>
                                        <input pInputText type="text" name="role_name" id="role_name" readonly
                                            [value]="userRole.name || '--'">
                                    </div>
                                </div>
                            </div>
                            <div class="username">
                                <div class="neo-input-wrapper">
                                    <label for="current_password">
                                        Description
                                    </label>
                                    <div>
                                        <input pInputText type="text" name="role_description" id="role_description" readonly
                                            [value]="userRole.description || 'Users can access only the enabled permissions specified below.'">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section with-bg">
            <div class="section-heading">
                Permission Details
            </div>
            <div class="section-content">
                <div class="section-item no-border">
                    <div class="neo-tabs">
                        @for (permission of permissionGroups; track $index) {
                        <div class="neo-tab" [class.active]="permission.active"
                            (click)="changeActivePermissionGroup(permission)">
                            <i [class]="'tab-icon ' + permission.icon"></i>
                            {{permission.label}}
                        </div>
                        }
                    </div>

                    <div class="active-sub-group-permissions">
                        <div class="neo-tabs wrap">
                            @for (subPermission of getActivePermissionsSubGroups(); track $index) {
                            <div class="neo-tab" [class.active]="subPermission.active" (click)="changeActiveSubPermissionGroup(subPermission)">
                                {{subPermission.label}}
                            </div>
                            }
                        </div>
                    </div>

                    <div class="permissions-heading">
                        Permissions
                    </div>

                    <div class="permissions-container">
                        @for (permission of getActiveSubPermissionsValues(); track $index) {
                        <div class="field-checkbox">
                            <p-checkbox name="category" [disabled]="true" [value]="permission.id" [(ngModel)]="permission.isChecked"
                                [binary]="true" [inputId]="permission.slug">
                            </p-checkbox>
                            <label [for]="permission.slug" [style]="{paddingLeft: '10px'}" class="permission-title">{{ permission.name }}</label>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
</div>
<p-toast></p-toast>

<!-- Old HTML -->
<!-- <div *ngIf="isLoading" class="loadingOverlay">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
</div>
<div class="pageInfo">
    <div class="settings-header" style="display: flex;justify-content:space-between; align-items: center; width: 100%;">
        <div style="display: flex;justify-content:space-between; align-items: center;">
            <em class="pi pi-user"></em>
            <p style="font-size: var(--fs-large); font-weight: var(--fw-bold);margin-left: 12.5px;">Primary Account</p>
        </div>
        <button style="background: none; border: none; cursor: pointer;" (click)="openAddTemplate('Edit Primary Account', 'pi-user')" (keyup.enter)="openAddTemplate('Edit Primary Account', 'pi-user')" tabindex="0">
            <em class="pi pi-pencil"></em>
        </button>
    </div>
</div>
<div class="info-card">
    <div [style]="{display: 'flex', flexWrap: 'wrap',borderBottom: '1px solid #DFE3E7',padding: '20px'}">
        <div *ngFor="let info of userInfo; let i = index" class="info-container">
            <div class="info-element">
                <span class="info-line"></span>
                <div [style]="{display: 'flex', flexDirection: 'column'} ">
                    <p [style]="{color: 'var(--fc-light-dark)'}">{{info.field}}</p>
                    <p [style]="{color: 'var(--fc-dark)', width: 'fit-content'}">{{info.value}}</p>
                </div>
            </div>
            <div style="margin-left: 16px;" *ngIf="info.field === 'Email/Username' || info.field === 'Password'">
                <div (click)="openAddTemplate((info.field === 'Email/Username' ? 'Change Email' : 'Change Password'), (info.field === 'Email/Username' ? 'pi-at' : 'pi-key'))"
                    class="change-button">
                    <div>
                        <em class="pi pi-pencil"></em>
                        <p>Change</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="permission_header"> <span>Role & Permissions</span></div>
    <div [style]="{display: 'block', flexWrap: 'wrap',margin: '0px 20px',borderBottom: '2px dashed #DFE3E7'}">
        <div class="info-container">
            <div class="info-element">
                <span class="info-line"></span>
                <div [style]="{display: 'flex', flexDirection: 'column'} ">
                    <p [style]="{color: 'var(--fc-light-dark)'}">Role</p>
                    <p [style]="{color: 'var(--fc-dark)', width: 'fit-content'}">{{userRole.name || '--'}}</p>
                </div>
            </div>
            <div class="info-element">
                <span class="info-line"></span>
                <div [style]="{display: 'flex', flexDirection: 'column',width: '100%'} ">
                    <p [style]="{color: 'var(--fc-light-dark)'}">Permissions</p>
                    <div class="tooltip_container">
                        <p [style]="{color: 'var(--fc-dark)', width: 'fit-content'}">{{userRole.description || 'Users can access only the enabled permissions specified below.'}}</p>
                        <span class="tooltip_icon" (mouseenter)="role_op.toggle($event)" (mouseleave)="role_op.hide()"><em class="pi pi-info" style="font-size: 12px;"></em></span>
                    </div>
                    <p-overlayPanel #role_op>
                        <ng-template pTemplate>
                            <div class="remainingItems">
                                <p >You can’t edit the permissions.</p>
                            </div>
                        </ng-template>
                    </p-overlayPanel>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isLoading">
        <div *ngFor="let slug of _module_slug_list">
            <div class="permission_container">
                <div class="permission_container_header" (click)="toggleExpand(slug)">
                    <span class="permission_logo">
                        <img src="../../../assets/icons-svg/Institution.svg" alt="module-icon"> {{slug.label}}
                    </span>
                    <span class="dropdown-icon">
                        <i [class]="slug.isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                    </span>
                </div>
                <div class="permission_container_content" *ngIf="slug.isExpanded">
                    <div *ngFor="let slugCheckbox of slug.value" class="field-checkbox">
                        <p-checkbox name="category" [disabled]="true" [value]="slugCheckbox.id"
                                    [(ngModel)]="slugCheckbox.isChecked" [binary]="true" [inputId]="slugCheckbox.slug">
                        </p-checkbox>
                        <label [for]="slugCheckbox.slug" [style]="{paddingLeft: '10px'}">{{ slugCheckbox.name }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<p-dialog [header]="sidebarAction" [(visible)]="addTemplateSidebar" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" styleClass="invite-candidate-dialog" (onHide)="emailForm.reset(); showPlaceholder = false; resetOTP()">
    <!-- <div class="addTemplate-header">
        <div class="addTemplate-heading"><em style="margin-right: 12.5px;" ngClass="{{sideActionIcon}}"
                class="pi"></em>{{sidebarAction}}</div>
        <div class="header-btn">
            <button *ngIf="sidebarAction === 'Edit Primary Account'" pButton pRipple type="submit" label="Save"
                (click)="saveTemplate()" class="p-button-raised p-button-text button-align"
                [loading]="saveBtnLoading"></button>
        </div>
    </div>
    <p-divider class="p-divider"></p-divider> -->
    <div *ngIf="sidebarAction === 'Change Email'" [formGroup]="emailForm" style="width: 40vw;">
        <div class="dialog-content">
            <div class="neo-input-wrapper">
                <label for="oldEmail" required>Current Email Address</label>
                <input pInputText type="text" name="oldEmail" id="oldEmail" formControlName="oldEmail" [disabled]="true"
                    readonly>
            </div>
            <div class="neo-input-wrapper">
                <label for="newEmail" required>New Email Address</label>
                <input pInputText type="text" name="newEmail" id="newEmail" formControlName="newEmail" [autofocus]="true">
            </div>
            <div *ngIf="verifiedMail">
                <p style="font-size:var(--fs-large); margin: 25px 0px 4px 0px;">Almost there!</p>
                <div style="font-size:var(--fs-medium);">
                    <p>An email with a verification code has been sent to</p>
                    <p>{{ emailForm.value.newEmail }}</p>
                </div>
                <div style="margin-top: 20px;">
                    <p>Didn't recieve a code? 
                        <span *ngIf="otpTimer() > 0" style="color: var(--clr-primary)">
                            Resend in <strong>{{otpCountdown()}}s</strong>
                        </span>
                        <span *ngIf="otpTimer() <= 0" style="color: var(--clr-primary); cursor: pointer;" (click)="verifyEmail()">
                            Request again
                        </span>
                    </p>
                </div>
            </div>
            <ng-otp-input class="{{(otp.length) ? 'otp-type' : ''}}" *ngIf="showOtpField"
                (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
            <span class="">
                <button
                    pButton class="create-btn"
                    *ngIf="showOtpField" (click)="verifyOtp()" (keyup.enter)="verifyOtp()" tabindex="0">
                    Confirm Email Changes
                </button>
            </span>
        </div>
        <div class="dialog-action">
            <button pTooltip="Old and new email cannot be same" tooltipPosition="top" class="create-btn"
                [tooltipDisabled]="emailForm.get('oldEmail')?.value !== emailForm.get('newEmail')?.value"
                (click)="emailForm.get('oldEmail')?.value === emailForm.get('newEmail')?.value ? null : verifyEmail()">
                Verify Email
            </button>
        </div>
    </div>
    <div *ngIf="sidebarAction === 'Change Password'" [formGroup]="passwordForm" style="width: 40vw;">
        <div class="dialog-content">
            <div class="neo-input-wrapper">
                <label for="currentPassword" required>Current Password</label>
                <div style="position: relative;">
                    <input pInputText [type]="currentPassShow ? 'text' : 'password'" name="currentPassword" id="currentPassword"
                        formControlName="currentPassword" placeholder="Enter your current password" style="padding-right: 34px !important;">
                    <span class="inputEmailIcon">
                        <em *ngIf="!this.currentPassShow"
                            (click)="this.currentPassShow = !this.currentPassShow; showPassword('curInput')" class="pi pi-eye"></em>
                        <em *ngIf="this.currentPassShow"
                            (click)="this.currentPassShow = !this.currentPassShow; showPassword('curInput')"
                            class="pi pi-eye-slash"></em>
                    </span>
                </div>
            </div>
            <div class="password-input-wrapper">
                <div class="neo-input-wrapper">
                    <label for="newPassword" required>New Password</label>
                    <input pInputText type="password" name="newPassword" id="newPassword" formControlName="newPassword"
                        placeholder="Enter your new password">
                </div>
                <div class="level-indicator" [class.medium]="passwordLevel.level == 2" [class.good]="passwordLevel.level >= 3">
                    {{passwordLevel.level === 2 ? "Medium" : (passwordLevel.level >= 3 ? "Good" : "Bad") }}
                    <div class="indicators">
                        <div class="indicator" [class.active]="passwordLevel.level >= 1"></div>
                        <div class="indicator" [class.active]="passwordLevel.level >= 2"></div>
                        <div class="indicator" [class.active]="passwordLevel.level >= 3"></div>
                    </div>
                </div>
                <div class="password-helper">
                    <div class="password-helper-item">
                        <div class="indicator" [class.invalid]="!passwordLevel.hasMinLength" [class.valid]="passwordLevel.hasMinLength">
                            <img src="./assets/icons-svg/check.svg" />
                        </div>
                        <span [class.invalid-helper]="!passwordLevel.hasMinLength" [class.active-helper]="passwordLevel.hasMinLength">
                            Be at least 8 characters long.
                        </span>
                    </div>
                    <div class="password-helper-item">
                        <div class="indicator" [class.invalid]="!passwordLevel.hasUpperCase" [class.valid]="passwordLevel.hasUpperCase">
                            <img src="./assets/icons-svg/check.svg" />
                        </div>
                        <span [class.invalid-helper]="!passwordLevel.hasUpperCase" [class.active-helper]="passwordLevel.hasUpperCase">
                            At least one uppercase letter (A-Z).
                        </span>
                    </div>
                    <div class="password-helper-item">
                        <div class="indicator" [class.invalid]="!passwordLevel.hasSpecialCharacter" [class.valid]="passwordLevel.hasSpecialCharacter">
                            <img src="./assets/icons-svg/check.svg" />
                        </div>
                        <span [class.invalid-helper]="!passwordLevel.hasSpecialCharacter"
                            [class.active-helper]="passwordLevel.hasSpecialCharacter">
                            {{'At least one special characters (! @ # $ % ^ & * %).'}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="neo-input-wrapper">
                <label for="confirmPassword" required>Confirm Password</label>
                <span style="position: relative;">
                    <input pInputText [type]="confirmPassShow ? 'text' : 'password'" name="confirmPassword" id="confirmPassword" formControlName="confirmPassword"
                        placeholder="Reenter your password" style="padding-right: 34px !important;">
                    <span class="inputEmailIcon">
                        <em *ngIf="!this.confirmPassShow"
                            (click)="this.confirmPassShow = !this.confirmPassShow; showPassword('confirmInput')"
                            class="pi pi-eye"></em>
                        <em *ngIf="this.confirmPassShow"
                            (click)="this.confirmPassShow = !this.confirmPassShow; showPassword('confirmInput')"
                            class="pi pi-eye-slash"></em>
                    </span>
                </span>
                <div *ngIf="passwordForm.get('confirmPassword')?.errors?.['mismatch'] && passwordForm.get('newPassword')?.value && passwordForm.get('confirmPassword')?.value; else checksamepass" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
                    Passwords do not match
                </div>
                <ng-template #checksamepass>
                    <div *ngIf="passwordForm.get('newPassword')?.value && passwordForm.get('currentPassword')?.value && passwordForm.get('newPassword')?.value === passwordForm.get('currentPassword')?.value" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
                        Current and New Password cannot be same
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="dialog-action">
            <button type="button" class="create-btn" pButton label="Change My Password" [disabled]="(!passwordForm.valid) || (passwordForm.get('newPassword')?.value === passwordForm.get('currentPassword')?.value)"
                (click)="changePassword()">
            </button>
        </div>
    </div>
    <!-- <div *ngIf="sidebarAction === 'Change Email'" class="templateForm" [formGroup]="emailForm">
        <div style="display: flex; align-items: center;">
            <span class="p-float-label templateForm-elements">
                <input type="text" id="template-title" pInputText formControlName="oldEmail" [disabled]="true" readonly
                    [ngClass]="{'p-filled': true}">
                <label for="template-title">Current Email <span [style]="{color: '#E24A47'}">*</span></label>
            </span>
        </div>
        <div style="display: flex; align-items: center;">
            <span class="p-float-label templateForm-elements">
                <input type="text" id="template-title" pInputText formControlName="newEmail"
                    [ngClass]="{'p-filled': emailForm.value.newEmail}">
                <label for="template-title">New Email <span [style]="{color: '#E24A47'}">*</span></label>
            </span>
            <button pButton pTooltip="Old and new email cannot be same" tooltipPosition="top"
                [tooltipDisabled]="emailForm.get('oldEmail')?.value !== emailForm.get('newEmail')?.value"
                (click)="emailForm.get('oldEmail')?.value === emailForm.get('newEmail')?.value ? null : verifyEmail()"
                style="background: #326BEE33; color: var(--clr-primary); height: 2.5rem; margin-left: 27px; border-radius: 4px; display: flex; justify-content: center; align-items: center;cursor: pointer; border: none">
                <p style="padding:8px 18px; font-size:var(--fs-medium);">Verify Email</p>
            </button>
        </div>
        <div *ngIf="verifiedMail">
            <p style="font-size:var(--fs-large); margin: 50px 0px 10px 0px;">Almost there!</p>
            <div style="font-size:var(--fs-medium);">
                <p>An email with a verification code has been sent to</p>
                <p>{{ emailForm.value.newEmail }}</p>
            </div>
            <div style="margin-top: 20px;">
                <p>Didn't recieve a code? <span style="color: var(--clr-primary); cursor: pointer;"
                        (click)="verifyEmail()">Request again</span></p>
            </div>
        </div>
        <div style="margin-top: 20px;">
            <ng-otp-input class="{{(otp.length) ? 'otp-type' : ''}}" *ngIf="showOtpField"
                (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true}"></ng-otp-input>
        </div>
        <span style="margin-top: 30px; width:25vw !important" class="p-float-label templateForm-elements">
            <button
                style="padding:10px 25px; background-color:var(--clr-primary); color: var(--clr-white); border-radius: 4px; border: none; cursor: pointer;"
                *ngIf="showOtpField" (click)="verifyOtp()" (keyup.enter)="verifyOtp()" tabindex="0">
                Confirm Email Changes
            </button>
        </span>
    </div> -->

    <!-- <div *ngIf="sidebarAction === 'Change Password'" class="templateForm" [formGroup]="passwordForm">
        <span class="p-float-label templateForm-elements">
            <input formControlName="currentPassword" class="inputEmail curInput inputtext"
                [ngClass]="{ 'p-filled':passwordForm.value.currentPassword }" type="password" id="template-title"
                pInputText />
            <label for="inputtext">Current Password <span [style]="{color: '#E24A47'}"> *</span></label>
            <span class="inputEmailIcon">
                <em *ngIf="this.currentPassShow"
                    (click)="this.currentPassShow = !this.currentPassShow; showPassword('curInput')"
                    class="pi pi-eye"></em>
                <em *ngIf="!this.currentPassShow"
                    (click)="this.currentPassShow = !this.currentPassShow; showPassword('curInput')"
                    class="pi pi-eye-slash"></em>
            </span>
        </span>
        <span class="p-float-label templateForm-elements">
            <input formControlName="newPassword" class="inputEmail newInput inputtext"
                [ngClass]="{ 'p-filled':passwordForm.value.newPassword }" type="password" id="template-title"
                pInputText />
            <label for="inputtext">New Password <span [style]="{color: '#E24A47'}"> *</span></label>
            <span class="inputEmailIcon">
                <em *ngIf="this.newPassShow" (click)="this.newPassShow = !this.newPassShow; showPassword('newInput')"
                    class="pi pi-eye"></em>
                <em *ngIf="!this.newPassShow" (click)="this.newPassShow = !this.newPassShow; showPassword('newInput')"
                    class="pi pi-eye-slash"></em>
            </span>
        </span>

        <span class="p-float-label templateForm-elements">
            <div style="margin: 1vh 0; width:25vw !important">
                <p>Password must be 8-30 characters long and contain at least one lowercase letter, one uppercase letter, one digit, and one special character</p>
            </div>
        </span>
        <span class="p-float-label templateForm-elements">
            <input formControlName="confirmPassword" class="inputEmail confirmInput inputtext"
                [ngClass]="{ 'p-filled':passwordForm.value.confirmPassword, 'ng-invalid': passwordForm.get('confirmPassword')?.errors?.['mismatch'] }" type="password" id="template-title"
                pInputText />
            <label for="inputtext">Confirm Password <span [style]="{color: '#E24A47'}"> *</span></label>
            <span class="inputEmailIcon">
                <em *ngIf="this.confirmPassShow"
                    (click)="this.confirmPassShow = !this.confirmPassShow; showPassword('confirmInput')"
                    class="pi pi-eye"></em>
                <em *ngIf="!this.confirmPassShow"
                    (click)="this.confirmPassShow = !this.confirmPassShow; showPassword('confirmInput')"
                    class="pi pi-eye-slash"></em>
            </span>
        </span>
        <div *ngIf="passwordForm.get('confirmPassword')?.errors?.['mismatch'] && passwordForm.get('newPassword')?.value && passwordForm.get('confirmPassword')?.value" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
            Passwords do not match
        </div>
        <div *ngIf="passwordForm.get('newPassword')?.value && passwordForm.get('currentPassword')?.value && passwordForm.get('newPassword')?.value === passwordForm.get('currentPassword')?.value" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
            Current and New Password cannot be same
        </div>
        <span class="p-float-label templateForm-elements">
            <div style="margin: 1vh 0; width:25vw !important">
                <p>Make sure to change your application password.</p>
            </div>
        </span>
        <span style="margin-top: 30px; width:25vw !important" class="p-float-label templateForm-elements">
            currentPassword {{passwordForm.get('currentPassword')?.value}}
            <button type="button" pButton label="Change My Password" [disabled]="(!passwordForm.valid) || (passwordForm.get('newPassword')?.value === passwordForm.get('currentPassword')?.value)"
                (click)="changePassword()">
            </button>
        </span>

    </div> -->

    <!-- <div *ngIf="sidebarAction === 'Edit Primary Account'" class="templateForm" [formGroup]="accountDetails">
        <div style="display: flex; align-items: center;">
            <span class="p-float-label templateForm-elements">
                <input class="inputtext" type="email" id="template-title" pInputText formControlName="email"
                    [ngClass]="{'p-filled': accountDetails.value.email}" [(ngModel)]="emailEdit"
                    style="max-width: 32vw !important;">
                <label for="template-title">Email/Username</label>
            </span>
            <div (click)="openAddTemplate('Change Email', 'pi-at')" class="change-button" style="margin: 0 0 0 20px;">
                <div>
                    <em class="pi pi-pencil"></em>
                    <p>Change</p>
                </div>
            </div>
        </div>

        <div style="display: flex; align-items: center;">
            <span class="p-float-label templateForm-elements">
                <input class="inputtext" type="text" id="template-title" pInputText formControlName="password"
                    [ngClass]="{'p-filled': accountDetails.value.password}" [(ngModel)]="passwordEdit"
                    style="max-width: 32vw !important;">
                <label for="template-title">Password</label>
            </span>
            <div (click)="openAddTemplate('Change Password', 'pi-key')" class="change-button"
                style="margin: 0 0 0 20px;">
                <div>
                    <em class="pi pi-pencil"></em>
                    <p>Change</p>
                </div>
            </div>
        </div>
        <span class="p-float-label">
            <p-inputNumber class="acc-phNo" id="inputtext" [useGrouping]="false" formControlName="mobile"
                [style]="{maxWidth: '32vw !important'}" [maxlength]="10">
            </p-inputNumber>
            <label for="inputtext">Mobile Number</label>
        </span>
    </div> -->
</p-dialog>